<input 
    class="form-control sg-input__input"
    [class.sg-input__input]="!noBorder"
    [class.sg-input-group__input-molecule]="noBorder"
    [type]="inputType"
    [id]="inputId"
    [name]="inputName"
    [placeholder]="placeholder"
    [disabled]="inputDisabled"
    (input)="updateValue($event)"
    (focus)="focus.emit($event)"
    (blur)="blur.emit($event)"
    [value]="_value"
/>

<small
    *ngFor="let error of errors"
    class="form-text"
    [class.sg-input__error]="errors.length"
>
    {{ error.title }}
</small>
